export const GDPR_COOKIE_KEY_PREFIX = 'GDPRConsent';

export const COOKIE_POLICY_URL = 'http://www.sega.co.uk/cookiepolicy';


// WEBPACK FOOTER //
// ./lib/rlink-cookies/constants.js